import React from 'react';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';
import Typography from '@mui/material/Typography';
import { USERS_MODALS } from 'src/utils/constants';

const HabilitarDeshabilitarUsuario = (props) => {
  const { open, close, flag, afterConfirm } = props;
  const { fetch } = useFetch();
  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);
  const confirmHandler = async () => {
    const nuevo_estado = flag === USERS_MODALS.HABILITAR_USUARIO ? 1 : 0;
    await fetch(`/usuarios/${props.data.id}`, {
      method: 'PATCH',
      data: { estado: nuevo_estado },
    });
    afterConfirm();
    close();
  };

  return (
    <Modal
      title={
        flag === USERS_MODALS.HABILITAR_USUARIO
          ? `Habilitar Usuario`
          : 'Deshabilitar Usuario'
      }
      content={
        <>
          <Typography>¿Estás seguro de efectuar este cambio? </Typography>
        </>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={true}
      onConfirm={confirmHandler}
    />
  );
};

export default HabilitarDeshabilitarUsuario;
